import {
  useQuery,
  useMutation,
} from '@tanstack/react-query';
import { getMethod, postMethod } from '../../api/services';

const AFFILIATE_LINKS = "/partners/referral_plans_data";
const CREATE_NEW_PLAN = "/partners/create_new_plan";

export function useFetchAffiliateLinks({axiosInstance, ...requestOptions }) {
  return useQuery({
    ...requestOptions,
    queryKey: ['affiliate-links'],
    queryFn: () => getMethod(AFFILIATE_LINKS, axiosInstance),
    select: (response) => response.data,
    placeholder: [],
  });
}

export function useCreateNewPlan({axiosInstance, ...requestOptions }) {
  return useMutation({
    ...requestOptions,
    mutationFn:(postBody) => postMethod(CREATE_NEW_PLAN, postBody, axiosInstance),
  });
}